module.exports = __webpack_public_path__ + "img/xs_bg.d4e5bfaf.png";